import { Input } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceInput",
  mixins: [Input, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    inputDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
